module.exports = __webpack_public_path__ + "static/img/banner01.4bb899e2.png";